import React from 'react';
import PropTypes from 'prop-types';

import { get } from 'lodash-es';
import { Row, Col } from 'reactstrap';

import { getVehiclePhoto } from 'site-modules/shared/components/lead-form/utils/utils';
import { DealerInfo } from 'site-modules/shared/components/lead-form/unified-lead-form/components/dealer/dealer-info';

import './card.scss';

export function DealerCard({ leadTarget, showDealerMakeStockImage = false }) {
  const { dealer, leadAttributes } = leadTarget;
  const distance = get(leadAttributes, 'distance');

  const vehicleInfo = get(dealer, 'vehicleInfo', {});
  const { year, make, model } = vehicleInfo;
  const vehicleLabel = `${year} ${make} ${model}`;
  const photoUrl = getVehiclePhoto({ styleInfo: vehicleInfo }, showDealerMakeStockImage);

  return showDealerMakeStockImage ? (
    <Row>
      <Col xs={4}>
        <img className="w-100" src={photoUrl} alt={vehicleLabel} />
      </Col>
      <Col xs={8}>
        <div className="mb-0_75 me-0_25 text-gray-darker fw-medium">{vehicleLabel}</div>
        <DealerInfo dealerInfo={dealer} distance={distance} />
      </Col>
    </Row>
  ) : (
    <DealerInfo dealerInfo={dealer} distance={distance} />
  );
}

DealerCard.propTypes = {
  leadTarget: PropTypes.shape({
    dealer: PropTypes.shape({}).isRequired,
    leadAttributes: PropTypes.shape({
      distance: PropTypes.number,
    }).isRequired,
  }).isRequired,
  showDealerMakeStockImage: PropTypes.bool,
};
